import Meta from '@/components/common/Meta'

import StorageMovingAndStudentStoragePage from '@/v2/components/pages/landing-pages/storage-moving-and-student-storage-page'
import { LANDING_PAGES_META_CONTENTS } from '@/v2/constants/pages/landing-pages/meta/landing-pages-meta-content'
import { metaImages, ogImages } from '@/v2/constants/pages/landing-pages/storage-moving-and-student-storage-page'

interface StorageMovingAndStudentStoragePageProps {}

const Page: React.FC<StorageMovingAndStudentStoragePageProps> = () => {
  return (
    <>
      <Meta
        title={
          LANDING_PAGES_META_CONTENTS.storage_moving_and_student_storage.title ??
          LANDING_PAGES_META_CONTENTS.default?.title ??
          ''
        }
        keywords={
          LANDING_PAGES_META_CONTENTS.storage_moving_and_student_storage?.keywords ??
          LANDING_PAGES_META_CONTENTS.default?.keywords ??
          ''
        }
        description={
          LANDING_PAGES_META_CONTENTS.storage_moving_and_student_storage?.description ??
          LANDING_PAGES_META_CONTENTS.default?.description ??
          ''
        }
        openGraph={{
          images: ogImages
        }}
        searchImages={metaImages}
      />

      <StorageMovingAndStudentStoragePage />
    </>
  )
}

export default Page
